import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var HttpResponse = /*#__PURE__*/function () {
  function HttpResponse(options) {
    _classCallCheck(this, HttpResponse);
    this.statusCode = options.statusCode;
    this.reason = options.reason;
    this.headers = options.headers || {};
    this.body = options.body;
  }
  _createClass(HttpResponse, null, [{
    key: "isInstance",
    value: function isInstance(response) {
      if (!response) return false;
      var resp = response;
      return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
  }]);
  return HttpResponse;
}();